import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import Footer from './Footer';
import { fetchReferralDetail } from '../store/actions/brand';
import { isMobile } from "react-device-detect";
import { faIgloo } from '@fortawesome/free-solid-svg-icons';

class Referral extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isValidPage: true,
			deepLink: ''
		};
	}

	componentDidMount() {

		const {
			match: {
				params: { referenceCode },
			},
		} = this.props;
		this.props
			.fetchReferralDetail(referenceCode)
			.then((res) => {
				this.generateDeepLik(res)
			})
			.catch(() => this.setState({ isValidPage: false }));
	}

	generateDeepLik(data) {
		const {
			match: {
				params: { referenceCode },
			},
		} = this.props;
		const linkData = {
			campaign: 'content 123',
			channel: 'facebook',
			feature: 'dashboard',
			stage: 'new user',
			tags: [ 'tag1', 'tag2', 'tag3' ],
			alias: '',
			data: {
			  'referralCode': referenceCode,
			  '$og_title': data.displayName,
			  '$og_description': 'Access our creative exercises and workouts in the Fitbanx app.',
			  '$og_image_url': data.referralImgUrl
			}
		  };
		  window.branch.link(linkData, (err, link) => {
			this.setState({
				deepLink:link
			})
		  });
	}

	renderReferralImage() {
		const { referenceDetail } = this.props;
		return referenceDetail && referenceDetail.referralImgUrl ? (
			<img src={referenceDetail.referralImgUrl} width="400px" alt="Thumb" />
		) : (
			<img src="/assets/img/referral.jpg" width="400px" alt="Thumb" />
		);
	}

	render() {

		const { referenceDetail } = this.props;
		const referralContent = referenceDetail.referralContent
		let content = 'Access our creative exercises and workouts in the Fitbanx app.';
		if(referralContent && referralContent !== '') {
			content = referralContent;
		}

		return (
			<Fragment>
				<Header {...this.props} />
				<div
					style={{ paddingBottom: '30px' }}
					id="overview"
					className="work-list-area default-padding"
				>
					{this.state.isValidPage ? (
						<div className="container">
							<div className="row">
								<div className="col-md-6 thumb text-center">
									{this.renderReferralImage()}
								</div>
								<div className="col-md-6 info follow-me-top text-center">
									<h3>
										{ content }
									</h3>
									<div className="col-md-12" style={{ marginTop: '20px' }}>
										<div className="col-md-6">
										{
											isMobile ?
												<a href={this.state.deepLink}>
													<img src="/assets/img/app-store.png" alt="app-store" />
												</a>
										   : <a data-toggle="modal" data-target="#openInMobile" >
										   		<img src="/assets/img/app-store.png" alt="app-store" />
									   		</a>
										}
										</div>
										<div className="col-md-6">
											{
												isMobile ?
												<a href={this.state.deepLink}>
													<img
														src="/assets/img/play-store.png"
														alt="play-store"
													/>
												</a>
											: <a data-toggle="modal" data-target="#openInMobile">
												<img
													src="/assets/img/play-store.png"
													alt="play-store"
												/>
											</a>
											}
										</div>
										<div className="col-md-12">
											<h5 style={{ marginTop: '20px', fontSize: '60px' }}>
												<em>Free Download</em>
											</h5>
										</div>
									</div>
								</div>
								<div className="col-md-12 col-sm-12 equal-height item">
									<div className="text-center">
										<img
											style={{ margin: '50px auto' }}
											src="/assets/img/logo.png"
											width="300"
											alt="logo"
										/>
									</div>
								</div>
							</div>
						</div>
					) : (
						<div className="container">
							<div className="row">
								<div className="col-md-12 info follow-me-top text-center">
									<h3>Not Found.</h3>
								</div>
								<div className="col-md-12 col-sm-12 equal-height item">
									<div className="text-center">
										<img
											style={{ margin: '50px auto' }}
											src="/assets/img/logo.png"
											width="300"
											alt="logo"
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
				<Footer {...this.props} />
			</Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
		referenceDetail: state.brand && state.brand.referenceDetail,
	};
}

const mapDispatchToProps = dispatch => {
	return {
		fetchReferralDetail: referenceCode => {
			return dispatch(fetchReferralDetail(referenceCode));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	withRef: true,
})(Referral);



// WEBPACK FOOTER //
// ./src/components/Referral.js